import React from 'react';
import { useTranslation } from 'react-i18next';
import { get, has } from 'lodash';
import { DsTag, DsIcon, DsLoader } from '@tokenyico/design-system/dist/reactJS';
import { datetimeFormat } from '@tokenyico/design-system';

const MessagesList = ({
  messages,
  selectedMessage,
  setSelectedMessage,
  setShowMessageList,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {isLoading ? (
        <div className="_p(4) _m:x(auto)" style={{ width: '20%' }}>
          <DsLoader version="dots" color="var(--blue-500)" />
        </div>
      ) : (
        <ul className="_flex:column">
          {messages.map((message) => {
            const isSelected = selectedMessage && selectedMessage.id === message.id;
            return (
              <li
                onClick={() => {
                  setSelectedMessage(message);
                  setShowMessageList(false);
                }}
                key={get(message, 'id')}
                className="_flex:row _flex:align(stretch)"
                style={{
                  background: isSelected && 'var(--white)',
                  borderLeft: isSelected && '2px solid var(--primary)',
                  borderBottom: !isSelected && '1px solid var(--grey-500)',
                  boxShadow: isSelected && 'var(--shadow-1)',
                  opacity: !isSelected && !has(message, 'unseen') && 0.8,
                }}
              >
                {has(message, 'unseen') ? (
                  <>
                    <DsIcon
                      name="point"
                      size="0.5rem"
                      className="_m:right(4)"
                      style={{
                        filter: 'drop-shadow(0px 0px 2px var(--green-500))',
                        fill: 'var(--green-500)',
                        color: 'var(--green-500)',
                        alignSelf: 'center',
                      }}
                    />
                  </>
                ) : (
                  <>
                    {get(message, 'sent') ? (
                      <DsIcon
                        name="sent"
                        size="0.9375rem"
                        className="_m:right(3) _text-grey-700"
                        style={{
                          alignSelf: 'center',
                        }}
                      />
                    ) : (
                      <DsIcon
                        name="point"
                        size="0.5rem"
                        className="_m:right(4)"
                        style={{
                          alignSelf: 'center',
                          fill: 'var(--grey-700)',
                        }}
                      />
                    )}
                  </>
                )}

                <div className="message__center _flex:column _m:left(2) _m:right(3)">
                  <div
                    className={
                      isSelected
                        ? '_text:sm _text-overflow:ellipsis _text(500)'
                        : '_text:sm _text-overflow:ellipsis'
                    }
                    style={{ color: isSelected && 'var(--primary)' }}
                  >
                    <span className={has(message, 'unseen') && '_text(500)'}>
                      {get(message, 'subject')}
                    </span>
                  </div>
                  <div className="_text:xs _text-overflow:ellipsis _text-grey-900 _m:top(2)">
                    {get(message, 'sent') ? (
                      <>
                        <span className="_text-grey-800"> {t('shared.to')}: </span>
                        {message.to && message.to.length === 1 ? (
                          <span>{get(message, 'to[0].address')}</span>
                        ) : (
                          <span>{`${get(message, 'to[0].address')}, + ${
                            message.to.length - 1
                          }`}</span>
                        )}
                      </>
                    ) : (
                      <>
                        <span className="_text-grey-800"> {t('shared.from')}: </span>
                        <span>{get(message, 'from.address')}</span>
                      </>
                    )}
                  </div>
                </div>
                <div
                  className="message__right _flex:column _flex:justify(space-between) _flex:align(end)"
                  style={{ marginLeft: 'auto' }}
                >
                  {has(message, 'unseen') ? (
                    <>
                      <span className="_text:xs _text-grey-900 _m:bottom(3)">
                        {datetimeFormat(message.date)}
                      </span>
                      <DsTag
                        label={t('shared.unread')}
                        version="success"
                        size="xs"
                        className="_text-overflow:ellipsis"
                        style={{ maxWidth: '10rem' }}
                      />
                    </>
                  ) : (
                    <>
                      <span className="_text:xs _text-grey-900 _m:bottom(3)">
                        {datetimeFormat(message.date)}
                      </span>
                      <DsTag
                        label={`${t('shared.sentBy')}: ${get(message, 'from.address')}`}
                        version="info"
                        size="xs"
                        className="_text-overflow:ellipsis"
                        style={{ maxWidth: '9rem' }}
                      />
                    </>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};

export default MessagesList;
